// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AblaufRouteImport } from './routes/ablauf'
import { Route as AgbRouteImport } from './routes/agb'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as FriseurTerminHeuteRouteImport } from './routes/friseur-termin-heute'
import { Route as FriseurWerbungRouteImport } from './routes/friseur-werbung'
import { Route as GuideRouteImport } from './routes/guide'
import { Route as PreiseRouteImport } from './routes/preise'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedOnboardingRouteImport } from './routes/_authenticated/onboarding'
import { Route as SSlugRouteImport } from './routes/s.$slug'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin.index'
import { Route as AuthenticatedAdminSalonsRouteImport } from './routes/_authenticated/admin.salons'
import { Route as AuthenticatedAdminSystemRouteImport } from './routes/_authenticated/admin.system'
import { Route as AuthenticatedDashboardIndexRouteImport } from './routes/_authenticated/dashboard.index'
import { Route as AuthenticatedDashboardCoinsRouteImport } from './routes/_authenticated/dashboard.coins'
import { Route as AuthenticatedDashboardSettingsRouteImport } from './routes/_authenticated/dashboard.settings'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AblaufRoute = AblaufRouteImport.update({
            id: '/ablauf',path: '/ablauf',getParentRoute: () => rootRouteImport
          })
const AgbRoute = AgbRouteImport.update({
            id: '/agb',path: '/agb',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const FriseurTerminHeuteRoute = FriseurTerminHeuteRouteImport.update({
            id: '/friseur-termin-heute',path: '/friseur-termin-heute',getParentRoute: () => rootRouteImport
          })
const FriseurWerbungRoute = FriseurWerbungRouteImport.update({
            id: '/friseur-werbung',path: '/friseur-werbung',getParentRoute: () => rootRouteImport
          })
const GuideRoute = GuideRouteImport.update({
            id: '/guide',path: '/guide',getParentRoute: () => rootRouteImport
          })
const PreiseRoute = PreiseRouteImport.update({
            id: '/preise',path: '/preise',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedOnboardingRoute = AuthenticatedOnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => AuthenticatedRouteRoute
          })
const SSlugRoute = SSlugRouteImport.update({
            id: '/s/$slug',path: '/s/$slug',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSalonsRoute = AuthenticatedAdminSalonsRouteImport.update({
            id: '/salons',path: '/salons',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSystemRoute = AuthenticatedAdminSystemRouteImport.update({
            id: '/system',path: '/system',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedDashboardIndexRoute = AuthenticatedDashboardIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedDashboardRoute
          })
const AuthenticatedDashboardCoinsRoute = AuthenticatedDashboardCoinsRouteImport.update({
            id: '/coins',path: '/coins',getParentRoute: () => AuthenticatedDashboardRoute
          })
const AuthenticatedDashboardSettingsRoute = AuthenticatedDashboardSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedDashboardRoute
          })





const AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminSalonsRoute: AuthenticatedAdminSalonsRoute,AuthenticatedAdminSystemRoute: AuthenticatedAdminSystemRoute,AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute
}

const AuthenticatedAdminRouteWithChildren = AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)




const AuthenticatedDashboardRouteChildren = {
  AuthenticatedDashboardCoinsRoute: AuthenticatedDashboardCoinsRoute,AuthenticatedDashboardSettingsRoute: AuthenticatedDashboardSettingsRoute,AuthenticatedDashboardIndexRoute: AuthenticatedDashboardIndexRoute
}

const AuthenticatedDashboardRouteWithChildren = AuthenticatedDashboardRoute._addFileChildren(AuthenticatedDashboardRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,AuthenticatedDashboardRoute: AuthenticatedDashboardRouteWithChildren,AuthenticatedOnboardingRoute: AuthenticatedOnboardingRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AblaufRoute: AblaufRoute,AgbRoute: AgbRoute,AuthRoute: AuthRoute,FaqRoute: FaqRoute,FriseurTerminHeuteRoute: FriseurTerminHeuteRoute,FriseurWerbungRoute: FriseurWerbungRoute,GuideRoute: GuideRoute,PreiseRoute: PreiseRoute,SSlugRoute: SSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)